interface LegacySpinnerProps {
  message?: string;
}

export function LegacySpinner({ message }: LegacySpinnerProps) {
  return (
    <div className="legacy-spinner">
      <div className="ey-spinner-line" aria-hidden="true" />
      <div className="ey-spinner-line middle-line" aria-hidden="true" />
      <div className="ey-spinner-line" aria-hidden="true" />
      {message ? <div className="legacy-spinner__message">{message}</div> : null}
    </div>
  );
}
